import React from 'react';
import { social } from '../../portfolio';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import LogoDevIcon from '@mui/icons-material/LogoDev';
import { useAnimate } from "framer-motion";
import './SocialSection.css';

export default function SocialSection() {
  return (
    <section className="social-section">
      <h2>🔗 Connect with Me</h2>
      <div className="social-icons">
        {social.github && (
          <a href={social.github} target="_blank" rel="noopener noreferrer">
            <GitHubIcon />
          </a>
        )}
        {social.linkedin && (
          <a href={social.linkedin} target="_blank" rel="noopener noreferrer">
            <LinkedInIcon />
          </a>
        )}
        {social.twitter && (
          <a href={social.twitter} target="_blank" rel="noopener noreferrer">
            <TwitterIcon />
          </a>
        )}
        {social.dev && (
          <a href={social.dev} target="_blank" rel="noopener noreferrer">
            <LogoDevIcon/>
          </a>
        )}

      </div>
    </section>
  )
}
